<template>
  <div class="news-and-footer">
    <div class="page_content">
      <h3>Notice of Exhibiting at Beautyworld Japan Nagoya</h3>
      <br>

      <div class="news_image">
        <img src="/assets/img/bwn09_outline_cube_L_jp.jpg" alt="Beautyworld Japan Nagoya 2026">
      </div>

      <p>
      We will be exhibiting at Beautyworld Japan Nagoya.<br>
      You will be able to try our professional machine Dr-PRO MAX, released last year, as well as our retail beauty device Dr-PRO BEAUTY SECRET.<br>
      Please feel free to visit our booth.
      </p>

      <p>
       Date: March 23 (Mon) – March 25 (Wed), 2026<br>
       Time: 10:00 – 17:00 (Until 16:30 on the final day)<br>
       Venue: Port Messe Nagoya Exhibition Hall 1 (3-2-1 Kinjofuto, Minato-ku, Nagoya, Aichi 455-0848, Japan)<br>
       Exhibitor: Scandinavia Service Co., Ltd.<br>
       Booth Number: 1A-C038
<br>
      </p>

      <p class="reserve">
        Advance reservation here:
        <a
          href="https://docs.google.com/forms/d/1O3wxWJMYds2nNn70b0cBvWG5iR9Nr0pCdcw_adCqbpU/edit"
          target="_blank"
          rel="noopener"
        >
          Reservation Form
        </a>
      </p>

      <footer2></footer2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'news20260323',
  components: {
    footer2: () => import('../components/Footer2.vue'),
  },
}
</script>

<style lang="scss" scoped>
.news-and-footer {
  margin-top: 80px;
}

.news_image {
  margin: 10px 0 25px;
}

.news_image img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.reserve a {
  text-decoration: underline;
}

@media (max-width: 600px) {
  .news-and-footer {
    margin-top: 30px;
  }
}
</style>